import { fabric } from 'fabric';
import deleteIcon from '../../assets/control/delete_icon.svg'
import scaleIcon from '../../assets/control/scale_icon.svg'
import touchRotateIcon from '../../assets/control/touch_rotate_icon.svg'
import rotateNinetyIcon from '../../assets/control/rotate_ninety_icon.svg'
import DEFINE from './define';

export default class ToolBase {
    parent = null;
    canvas = null;

    name = "";

    deleteIcon = deleteIcon;
    scaleIcon = scaleIcon;
    touchRotateIcon = touchRotateIcon;
    rotateNinetyIcon = rotateNinetyIcon;

    isMove = false;

    constructor(parent) {
        this.parent = parent;
        this.canvas = parent.getCanvas();
    }

    setValue(value) {
        // console.log(this.name + ":value" + value);

        if (value == {}) return;
    }

    getLimitPointer(pointer) {
        let setting = this.parent.getDrawSetting(DEFINE.DRAW_TYPE.LINE_SEGMENT);

        return {
            x: Math.max(0, Math.min(pointer.x, this.parent.initialCanvasSize.width - setting.strokeWidth)),
            y: Math.max(0, Math.min(pointer.y, this.parent.initialCanvasSize.height - setting.strokeWidth))
        }
    }

    //#region 生成與復原

    create() {
        // console.log(this.name + ":create");
        this.canvas.isDrawingMode = false;
    }

    recover(object) {
        // console.log(this.name + ":recover");
    }

    //#endregion

    //#region 控制器

    /**
     * 開關縮放控制器顯示
     * @param {*} enable 
     */
    enableScaleControl(target, enable = true) {
        let scaleControls = ["tl", "bl", "tr", "br", "ml", "mb", "mr", "mt"]

        scaleControls.forEach(control => {
            target['setControlVisible'](control, enable);
        });
    }

    getBasicControls() {
        return {
            ml: new fabric.Control({
                x: -0.5,
                y: 0,
                cursorStyleHandler: fabric.controlsUtils.scaleSkewCursorStyleHandler,
                actionHandler: fabric.controlsUtils.scalingXOrSkewingY,
                getActionName: fabric.controlsUtils.scaleOrSkewActionName,
                mouseUpHandler: this.addHistoryFunction.bind(this),
            }),
            mr: new fabric.Control({
                x: 0.5,
                y: 0,
                cursorStyleHandler: fabric.controlsUtils.scaleSkewCursorStyleHandler,
                actionHandler: fabric.controlsUtils.scalingXOrSkewingY,
                getActionName: fabric.controlsUtils.scaleOrSkewActionName,
                mouseUpHandler: this.addHistoryFunction.bind(this),
            }),
            mb: new fabric.Control({
                x: 0,
                y: 0.5,
                cursorStyleHandler: fabric.controlsUtils.scaleSkewCursorStyleHandler,
                actionHandler: fabric.controlsUtils.scalingYOrSkewingX,
                getActionName: fabric.controlsUtils.scaleOrSkewActionName,
                mouseUpHandler: this.addHistoryFunction.bind(this),
            }),
            mt: new fabric.Control({
                x: 0,
                y: -0.5,
                cursorStyleHandler: fabric.controlsUtils.scaleSkewCursorStyleHandler,
                actionHandler: fabric.controlsUtils.scalingYOrSkewingX,
                getActionName: fabric.controlsUtils.scaleOrSkewActionName,
                mouseUpHandler: this.addHistoryFunction.bind(this),
            }),
            tl: new fabric.Control({
                x: -0.5,
                y: -0.5,
                cursorStyleHandler: fabric.controlsUtils.scaleCursorStyleHandler,
                actionHandler: fabric.controlsUtils.scalingEqually,
                mouseUpHandler: this.addHistoryFunction.bind(this),
            }),
            tr: new fabric.Control({
                x: 0.5,
                y: -0.5,
                cursorStyleHandler: fabric.controlsUtils.scaleCursorStyleHandler,
                actionHandler: fabric.controlsUtils.scalingEqually,
                mouseUpHandler: this.addHistoryFunction.bind(this),
            }),
            bl: new fabric.Control({
                x: -0.5,
                y: 0.5,
                cursorStyleHandler: fabric.controlsUtils.scaleCursorStyleHandler,
                actionHandler: fabric.controlsUtils.scalingEqually,
                mouseUpHandler: this.addHistoryFunction.bind(this),
            }),
            br: new fabric.Control({
                x: 0.5,
                y: 0.5,
                cursorStyleHandler: fabric.controlsUtils.scaleCursorStyleHandler,
                actionHandler: fabric.controlsUtils.scalingEqually,
                mouseUpHandler: this.addHistoryFunction.bind(this),
            }),
        }
    }

    /**
     * 渲染控制器Icon
     * @param {*} icon 
     * @returns Function
     */
    renderIcon(icon) {
        return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
            let size = this.cornerSize;
            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(icon, -size / 2, -size / 2, size, size);
            ctx.restore();
        }
    }

    /**
     * 取得刪除控制器
     * @returns fabric.Control
     */
    getDeleteControl(options) {
        let img = document.createElement('img');
        img.src = this.deleteIcon;

        return new fabric.Control(Object.assign({
            x: 0,
            y: 0,
            offsetX: 0,
            offsetY: 0,
            cursorStyle: 'pointer',
            mouseUpHandler: this.deleteFunction.bind(this),
            render: this.renderIcon(img),
            cornerSize: 24
        }, options));
    }

    /**
     * 取得比例控制器
     * @returns fabric.Control
     */
    getScaleControl(options) {
        let img = document.createElement('img');
        img.src = this.scaleIcon;
        return new fabric.Control(Object.assign({
            x: 0,
            y: 0,
            offsetX: 0,
            offsetY: 0,
            cursorStyle: 'pointer',
            actionHandler: fabric.controlsUtils.scalingEqually,
            mouseUpHandler: this.addHistoryFunction.bind(this),
            actionName: 'resizing',
            render: this.renderIcon(img),
            cornerSize: 24
        }, options));
    }

    getRulerScaleControl(options) {
        let img = document.createElement('img');
        img.src = this.scaleIcon;
        return new fabric.Control(Object.assign({
            x: 0,
            y: 0,
            offsetX: 0,
            offsetY: 0,
            cursorStyle: 'pointer',
            actionHandler: fabric.controlsUtils.wrapWithFireEvent("scaling", fabric.controlsUtils.wrapWithFixedAnchor(this.rulerScaler)),
            mouseUpHandler: this.handleScaleMouseUp.bind(this),
            actionName: 'resizing',
            render: this.renderIcon(img),
            cornerSize: 24
        }, options));
    }

    rulerScaler(eventData, transform, x, y) {
        // console.log(eventData);
        // console.log(transform);
        // console.log(`${eventData}, ${transform}, ${x}, ${y}`);

        var target = transform.target;
        // console.log(target);
        if (!target.scaleCenter) {
            target.scaleCenter = new fabric.Point(target.left + 325, target.top - 18);

            target.scaleStart = new fabric.Point(x, y);

            target.beforeScaleX = target.scaleX
            target.beforeScaleY = target.scaleY

            target.firstDistance = target.scaleStart.distanceFrom(target.scaleCenter) / target.scaleX;
        }
        var newPoint = new fabric.Point(x, y);
        var scale = newPoint.distanceFrom(target.scaleCenter) / target.firstDistance;
        var oldScaleX = target.scaleX, oldScaleY = target.scaleY;

        //console.log(scale);

        target.set('scaleX', scale)
        target.set('scaleY', scale)

        return oldScaleX !== target.scaleX || oldScaleY !== target.scaleY;
    }

    handleScaleMouseUp(eventData, transform, x, y) {
        this.addHistoryFunction.bind(this);
        var target = transform.target;
        target.scaleCenter = null;
        target.scaleStart = null;
    }

    /**
     * 取得觸控旋轉控制器
     * @returns fabric.Control
     */
    getTouchRotateControl(options, type = true) {
        let img = document.createElement('img');
        img.src = this.touchRotateIcon;

        if (type) {
            return new fabric.Control(Object.assign({
                x: 0,
                y: 0,
                offsetX: 0,
                offsetY: 0,
                cursorStyle: 'pointer',
                actionHandler: fabric.controlsUtils.rotationWithSnapping,
                mouseUpHandler: this.addHistoryFunction.bind(this),
                actionName: 'rotate',
                render: this.renderIcon(img),
                cornerSize: 24
            }, options));
        } else {
            return new fabric.Control(Object.assign({
                x: 0,
                y: 0,
                offsetX: 0,
                offsetY: 0,
                cursorStyle: 'pointer',
                mouseDownHandler: this.RecordOrigAngleFunction.bind(this),
                actionHandler: this.CustomRotateFunction.bind(this),
                mouseUpHandler: this.addHistoryFunction.bind(this),
                actionName: 'rotate',
                render: this.renderIcon(img),
                cornerSize: 24
            }, options));
        }
    }

    /**
     * 取得旋轉90度控制器
     * @returns fabric.Control
     */
    getRotateNinetyControl(options) {
        let img = document.createElement('img');
        img.src = this.rotateNinetyIcon;

        return new fabric.Control(Object.assign({
            x: 0,
            y: 0,
            offsetX: 0,
            offsetY: 0,
            cursorStyle: 'pointer',
            mouseUpHandler: this.rotateNinetyFunction.bind(this),
            actionName: 'rotate',
            render: this.renderIcon(img),
            cornerSize: 24
        }, options));
    }

    /**
     * 刪除控制器事件
     * @param {*} eventData 
     * @param {*} transform 
     */
    deleteFunction(eventData, transform) {
        let target = transform.target;
        let canvas = target.canvas;

        this.parent.currentTool = null;
        canvas.remove(target);
        canvas.requestRenderAll();

        this.addHistoryFunction();
    }

    /**
     * 紀錄旋轉起始資訊
     * @param {*} eventData 
     * @param {*} transform 
     */
    RecordOrigAngleFunction(eventData, transform) {
        let target = transform.target;

        let slope = (eventData.offsetY - target.top) / (eventData.offsetX - target.left);
        let angle = (Math.atan(slope) / (Math.PI / 180));

        //同方向移動會根據是否超過180度而決定增減
        if (eventData.offsetX < target.left)
            angle += 180;

        if (-angle < 0) angle -= 360;

        target.originAngle = target.angle;
        target.offsetAngle = angle;
    }

    /**
     * 自訂旋轉控制器事件
     * @param {*} eventData 
     * @param {*} transform 
     */
    CustomRotateFunction(eventData, transform) {
        console.log(transform)
        let target = transform.target;
        let canvas = target.canvas;

        let slope = (eventData.offsetY - target.top) / (eventData.offsetX - target.left);
        let angle = (Math.atan(slope) / (Math.PI / 180));

        //同方向移動會根據是否超過180度而決定增減
        if (eventData.offsetX < target.left)
            angle += 180;

        angle -= target.offsetAngle;

        if (-angle < 0) angle -= 360;

        target.angle = target.originAngle + angle;

        canvas.requestRenderAll();
    }

    /**
     * 旋轉90度控制器事件
     * @param {*} eventData 
     * @param {*} transform 
     */
    rotateNinetyFunction(eventData, transform) {
        let target = transform.target;
        let canvas = target.canvas;

        if (target.angle % 90 == 0) {
            target.angle += 90;
        } else {
            target.angle = (Math.floor(target.angle / 90) + 1) * 90;
        }

        canvas.requestRenderAll();

        this.addHistoryFunction();
    }

    /**
     * 控制器事件紀錄
     * @param {*} eventData 
     * @param {*} transform 
     */
    addHistoryFunction(eventData, transform) {
        this.parent.addHistory();
    }

    //#endregion

    //#region 監聽事件

    mouseUp(o) {
        // console.log(this.name + ":mouse up", o);

        // this.parent.changeTool(null);
    }

    mouseDown(o) {
        // console.log(this.name + ":mouse down", o);
    }

    mouseMove(o) {
        // console.log(this.name + ":mouse move", o);
    }

    mouseUpBefore(o) {
        // console.log(this.name + ":mouse up before", o);
    }

    mouseDownBefore(o) {
        // console.log(this.name + ":mouse down before", o);
    }

    mouseMoveBefore(o) {
        // console.log(this.name + ":mouse move before", o);
    }

    mouseDBLClick(o) {
        // console.log(this.name + ":mouse double click", o);
    }

    mouseWheel(o) {
        // console.log(this.name + ":mouse wheel", o);
    }

    mouseOver(o) {
        // console.log(this.name + ":mouse over", o);
    }

    mouseOut(o) {
        // console.log(this.name + ":mouse out", o);
    }

    selectionCreated(o) {
        // console.log(this.name + ":selection created", o);
    }

    objectAdded(o) {
        // console.log(this.name + ":object added", o);
    }

    //#endregion

    //#region 群組事件

    ungroup(group) {
        const self = this;

        group.forEachObject((i) => {
            group.removeWithUpdate(i);
            self.canvas.add(i);
        });
    }

    addToGroup(objs) {
        console.log(objs)
        let group = new fabric.Group(objs);
        this.canvas.add(group).requestRenderAll();
        return group;
    }

    //#endregion
    /**
     * 
     * @param {string} src 
     * @returns {fabric.object}
     */
    loadSvgToGroup(src) {
        return new Promise((resolve, reject) => {
            fabric.loadSVGFromURL(src, (objects, options) => {
                const group = new fabric.util.groupSVGElements(objects, options);

                resolve(group);
            });
        })
    }
}